<ul class="container">
  @if (authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin"])) {
    <li>
      @if (currentFacilityId === "0") {
        <span>
          <div class="noselect bold">Select a Store</div>
        </span>
      }
      @if (currentFacilityId !== "0") {
        <span>
          <div class="noselect bold">{{ currentFacilityId }} - {{ currentFacilityName }}</div>
        </span>
      }
      <div>
        <mat-slide-toggle class="menu-item" [checked]="facilityStatus" (change)="updateStoreAvailability()">
          This store is {{ facilityStatus ? "open" : "closed" }}
        </mat-slide-toggle>
      </div>
      <div>
        <mat-slide-toggle
          class="menu-item"
          [checked]="displayHolidayOrders"
          [disabled]="currentFacilityId === '0'"
          (change)="updateHolidayOrdersDisplay()">
          {{ displayHolidayOrders ? "Holiday orders visible" : "Holiday orders hidden" }}
        </mat-slide-toggle>
      </div>
    </li>
  }
  @if (authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin", "Division"])) {
    <menu-group label="Store Settings">
      @if (authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin"])) {
        <menu-item
          label="Order Timing"
          icon-src="/assets/images/menu/Settings.svg"
          route="store-settings/order-timing"></menu-item>
      }
      <menu-item
        label="Contact Information"
        icon-src="/assets/images/menu/Settings.svg"
        route="store-settings/contact-info"></menu-item>
    </menu-group>
  }
  @if (authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin", "Division"])) {
    <menu-group label="Fulfillment Settings">
      <menu-item label="Walkpath Order" icon-src="/assets/images/menu/Walkpath.svg" route="walkpath-order"></menu-item>
      <menu-item
        label="Hand-off Settings"
        icon-src="/assets/images/menu/HandOff.svg"
        route="handoff-settings"></menu-item>
    </menu-group>
  }
  <menu-group label="Preparation Management">
    <menu-item label="Prep Locations" icon-src="/assets/images/menu/ChefHat.svg" route="prep-locations"></menu-item>
    <menu-item label="Manage Items" icon-src="/assets/images/menu/PrepLocations.svg" route="manage-items"></menu-item>
    <menu-item
      label="Manage Modifiers"
      icon-src="/assets/images/menu/ManageItems.svg"
      route="manage-modifiers"></menu-item>
  </menu-group>
</ul>
